package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import br.gov.go.pge.permanenciaweb.shared.MeDto
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

/**
 * Header shared by the secondary pages (Liberações, 403): the page title, a one-line explanation
 * and the session menu. The dashboard keeps its own live header (it also shows freshness/live
 * badges), but the menu itself is the same [UserMenu].
 */
@Composable
fun PageHeader(title: String, subtitle: String?, me: MeDto?, currentPath: String) {
    Row(
        modifier = Modifier
            .padding(top = 1.cssRem, right = 1.5.cssRem, bottom = 0.5.cssRem, left = 1.5.cssRem)
            .gap(1.cssRem)
            .alignItems(AlignItems.Baseline),
    ) {
        H1(attrs = Modifier.fontSize(1.25.cssRem).fontWeight(FontWeight.SemiBold).margin(0.cssRem).toAttrs()) {
            Text(title)
        }
        if (subtitle != null) {
            SpanText(subtitle, CaveatStyle.toModifier())
        }
        Spacer()
        UserMenu(me, currentPath)
    }
}
